import { observer } from 'mobx-react';
import React from 'react';
import './styles.css';

// Helpers
import { checkValidity, getURLSegment, handleSwitchInputKeys } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Textarea from 'react-textarea-autosize';

const InstitutionSettings = observer(class InstitutionSettings extends React.Component {
  constructor() {
    super();
    this.handleTabs = this.handleTabs.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
    this.toggleOption = this.toggleOption.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handlePermittedItem = this.handlePermittedItem.bind(this);
    this.handleProctorTypeInput = this.handleProctorTypeStatusInput.bind(this);
    this.subKeyIndex = this.subKeyIndex.bind(this);
    this.renderApproveOption = this.renderApproveOption.bind(this);
    this.renderProctorTypesEnabled = this.renderProctorTypesEnabled.bind(this);
    this.renderProctorTypesDisabled = this.renderProctorTypesDisabled.bind(this);
    this.renderReconnectionFields = this.renderReconnectionFields.bind(this);
    this.renderSessionConfigurationDropdown = this.renderSessionConfigurationDropdown.bind(this);
    this.renderModalityPresetDropdown = this.renderModalityPresetDropdown.bind(this);
    this.handleSessionConfigurationInput = this.handleSessionConfigurationInput.bind(this);
    this.handleModalityPresetInput = this.handleModalityPresetInput.bind(this);
    this.handleReconnectionInput = this.handleReconnectionInput.bind(this);
    this.subCategories = {};
  }

  componentWillMount() {
    const { AdminStore, ExamStore, SessionStore, SettingsStore } = this.props.store;

    SessionStore.getTimezones();
    SessionStore.getCurrencies();
    SessionStore.getSessionConfigurations();
    SessionStore.getProctorTypes();
    ExamStore.getModalityPresets();
    AdminStore.getCourseOfferings();
    SettingsStore.getInstituteSettings(this);

    this.state = {
      settings: {
        facialProcessing: '',
        timeZone: '',
        defaultCurrencyCode: '',
        proctorTypes: [],
        examNotes: '',
        requireManagerProctorApproval: false,
        requireManagerExamApproval: false,
        hidePermittedItemFields: [],
        pauseForProctorReview: false
      },
      activeTab: 1
    }

    // Select tab if present in url
    let urlTab = 1;

    switch (getURLSegment(this, 3)) {
      case 'exams':
        urlTab = 2;
        break;

      case 'proctors':
        urlTab = 3;
        break;

      default:
        urlTab = 1;
    }

    this.setState({
      activeTab: urlTab
    })
  }

  handleTabs(index) {
    this.setState({
      activeTab: index + 1,
    });

    // Update url
    let newPath = '/settings/institution/general';

    switch (index + 1) {
      case 2:
        newPath = '/settings/institution/exams';
        break;

      case 3:
        newPath = '/settings/institution/proctors';
        break;

      default:
        newPath = '/settings/institution/general';
    }

    this.props.routing.push(newPath);
  }

  toggleOption(e, key) {
    let settings = {...this.state.settings};

    if(e.target.value === 'false') {
      settings[key] = false;
    } else {
      settings[key] = true;
    }

    this.setState({
      settings
    });
  }

  handleInput(e) {
    let settings = { ...this.state.settings };

    settings.defaultTimezone = this.defaultTimezone.value || '';
    settings.defaultCurrencyCode = this.defaultCurrencyCode.value || '';
    settings.examNotes = this.examNotes.value || '';
    settings.enableWrittenExams = this.enableWrittenExams.checked;
    settings.defaultCourseOfferingSid = this.defaultCourseOfferingSid.value || '';
    settings.pauseForProctorReview = this.pauseForProctorReview.checked;
    //settings.facialProcessing = this.facialProcessing.checked;

    //Temporary fix while facialProcessing is just a toggle
    settings.facialProcessing = this.facialProcessing.checked ? 'detection' : 'off';

    if(this.defaultNewExamType) {
      settings.defaultNewExamType = this.defaultNewExamType.value || '';
    }

    this.setState({
      settings
    });
  }

  handlePermittedItem(e, item) {
    let settings = { ...this.state.settings };

    if(e.target.checked) {
      // Show item and remove from array
      const index = settings.hidePermittedItemFields.indexOf(item);
      settings.hidePermittedItemFields.splice(index, 1);
    } else {
      // Hide item and add to array
      settings.hidePermittedItemFields.push(item);
    }

    this.setState({
      settings
    });
  }

  handleProctorTypeStatusInput(e, subKeySid) {
    let settings = { ...this.state.settings };
    let index = this.subKeyIndex(subKeySid);
    if (~index) {
      settings.proctorTypes[index].status = e.target.value;
    } else {
      settings.proctorTypes.push({
        status: e.target.value,
        proctorTypeSubCategorySid: subKeySid,
        automaticallyApprove: true
      })
    }
    this.setState({
      settings
    });
  }

  handleProctorTypeApproveInput(e, index) {
    let settings = { ...this.state.settings };
    settings.proctorTypes[index].automaticallyApprove = e.target.checked;

    this.setState({
      settings
    });
  }

  handleReconnectionInput(e, subKeySid, fieldName) {
    let settings = { ...this.state.settings };
    let index = this.subKeyIndex(subKeySid);
    
    if (~index) {
      settings.proctorTypes[index][fieldName] = parseInt(e.target.value, 10) || null;
    } else {
      let newProctorType = {
        status: 'disabled',
        proctorTypeSubCategorySid: subKeySid,
        automaticallyApprove: true
      };
      newProctorType[fieldName] = parseInt(e.target.value, 10) || null;
      settings.proctorTypes.push(newProctorType);
    }
    
    this.setState({
      settings
    });
  }

  handleModalityPresetInput(e, subKeySid) {
    let settings = { ...this.state.settings };
    let index = this.subKeyIndex(subKeySid);

    if (~index) {
      if (settings.proctorTypes[index].status === 'disabled') {
        settings.proctorTypes[index].modalityOptionPresetSid = null;
      } else {
        settings.proctorTypes[index].modalityOptionPresetSid = e.target.value || null;
      }
    } else {
      settings.proctorTypes.push({
        status: 'disabled',
        proctorTypeSubCategorySid: subKeySid,
        automaticallyApprove: true,
        modalityOptionPresetSid: null
      });
    }

    this.setState({ settings });
  }

  handleSessionConfigurationInput(e, subKeySid) {
    let settings = { ...this.state.settings };
    let index = this.subKeyIndex(subKeySid);
    
    if (~index) {

      if (settings.proctorTypes[index].status === 'disabled') {
        settings.proctorTypes[index].sessionConfigurationSid = null;
      } else {
        // If enabled, proceed with setting the session configuration
        settings.proctorTypes[index].sessionConfigurationSid = e.target.value || null;
      }
      
    } else {
      let newProctorType = {
        status: 'disabled',
        proctorTypeSubCategorySid: subKeySid,
        automaticallyApprove: true,
        sessionConfigurationSid: null
      };
      settings.proctorTypes.push(newProctorType);
    }
    
    this.setState({
      settings
    });
  }

  subKeyIndex(subKeySid) {
    for (let i = 0; i < this.state.settings.proctorTypes.length; i++) {
      if (this.state.settings.proctorTypes[i].proctorTypeSubCategorySid === subKeySid) {
        return i;
      }
    }
    return -1;
  }

  renderApproveOption(index, translation, disabled) {
    if (~index && this.state.settings.proctorTypes[index].status !== 'disabled') {
      let proctorType = this.state.settings.proctorTypes[index];
      return (
        <div className="switch-list__option">
          <label
            htmlFor={`${proctorType.proctorTypeSubCategorySid}-auto`}
          >
            {translation.proctor_types.options.auto_approve}
          </label>

          {disabled &&
            <input
              type="checkbox"
              id={`${proctorType.proctorTypeSubCategorySid}-auto`}
              className="switch-input"
              value={proctorType.automaticallyApprove ? "1" : "0"}
              checked={proctorType.automaticallyApprove}
              disabled
            />
          }

          {!disabled &&
            <input
              type="checkbox"
              id={`${proctorType.proctorTypeSubCategorySid}-auto`}
              className="switch-input"
              value={proctorType.automaticallyApprove ? "1" : "0"}
              checked={proctorType.automaticallyApprove}
              onChange={e => this.handleProctorTypeApproveInput(e, index)}
              onKeyDown={handleSwitchInputKeys}
            />
          }

          <label
            className="switch-label"
            htmlFor={`${proctorType.proctorTypeSubCategorySid}-auto`}
          >
            <span className="meta">{translation.proctor_types.options.auto_approve}</span>
          </label>
        </div>
      )
    }
  }

  renderReconnectionFields(index, subKeySid, proctorType, sessionConfigurationType, translation) {
    // Return early if index is invalid
    if (!~index) {
      return null;
    }

    const currentProctorType = this.state.settings.proctorTypes[index];
    
    // Safety check: ensure currentProctorType exists
    if (!currentProctorType) {
      return null;
    }

    // Only show if proctor type status is not 'disabled'
    if (currentProctorType.status === 'disabled') {
      return null;
    }

    // Check if there are session configurations for this subtype
    if (sessionConfigurationType && sessionConfigurationType[subKeySid] && sessionConfigurationType[subKeySid].length > 0) {


      const renderReconnectionField = (fieldName, subKeySid, currentProctorType, translation, config) => {
        return (
          <div className="switch-list__option" key={fieldName}>
            <label htmlFor={`${subKeySid}-${config.idSuffix}`}>
              {config.label}

              {config.tooltip_text && (
              <div className="tooltip">
                <span
                  className="tooltip__label"
                  role="presentation"
                  aria-hidden="true"
                >(?)</span>

                <div
                  id="course-offering"
                  className="tooltip__body"
                  role="tooltip"
                >
                  {config.tooltip_text}
                </div>
              </div>
              )}

            </label>
            <input
              type="number"
              id={`${subKeySid}-${config.idSuffix}`}
              min="0"
              value={currentProctorType[fieldName] || ''}
              onChange={e => this.handleReconnectionInput(e, subKeySid, fieldName)}
            />
          </div>
        );
      };
      
      // Configuration for reconnection fields
      const reconnectionFieldConfigs = [
        {
          fieldName: 'maxReconnectionAttempts',
          idSuffix: 'max-reconnection',
          label: translation.proctor_types.reconnection.max_attempts,
          tooltip_text: translation.proctor_types.reconnection.max_attempts_tooltip
        },
        {
          fieldName: 'reconnectionInSessionLockoutPeriod',
          idSuffix: 'in-session-lockout',
          label: translation.proctor_types.reconnection.in_session_lockout,
          tooltip_text: translation.proctor_types.reconnection.in_session_lockout_tooltip
        },
        {
          fieldName: 'reconnectionLockoutPeriod',
          idSuffix: 'lockout-period',
          label: translation.proctor_types.reconnection.lockout_period,
          tooltip_text: translation.proctor_types.reconnection.lockout_period_tooltip
        }
      ];

      const fields = reconnectionFieldConfigs
        .map(config => renderReconnectionField(
          config.fieldName, 
          subKeySid, 
          currentProctorType, 
          translation, 
          config
        ));
      
      return fields.length > 0 ? fields : null;
    }
    return null;
  }

  renderSessionConfigurationDropdown(subKeySid, sessionConfigurationType, translation) {
    const index = this.subKeyIndex(subKeySid);

    // Return early if index is invalid
    if (!~index) {
      return null;
    }

    const currentProctorType = this.state.settings.proctorTypes[index];
    
    // Safety check: ensure currentProctorType exists
    if (!currentProctorType) {
      return null;
    }

    // Only show if proctor type status is not 'disabled'
    if (currentProctorType.status === 'disabled') {
      return null;
    }

    // Check if there are session configurations for this subtype
    if (sessionConfigurationType && sessionConfigurationType[subKeySid] && sessionConfigurationType[subKeySid].length > 0) {
      const configurations = sessionConfigurationType[subKeySid];
      let currentSessionConfigSid = currentProctorType.sessionConfigurationSid || '';

      // Set default to first configuration if none is selected
      if (!currentSessionConfigSid && configurations.length > 0) {
        currentSessionConfigSid = configurations[0].sid;
      }

      return (
        <div className="switch-list__option session-configuration-dropdown">
          <label htmlFor={`${subKeySid}-session-config`}>
            {translation.proctor_types.session_configuration}
            
              <div className="tooltip">
                <span
                  className="tooltip__label"
                  role="presentation"
                  aria-hidden="true"
                >(?)</span>

                <div
                  id="session-configuration-tooltip"
                  className="tooltip__body"
                  role="tooltip"
                >
                  {translation.proctor_types.session_configuration_tooltip}
                </div>
              </div>
            


          </label>
          <label className="select" htmlFor={`${subKeySid}-session-config`}>
            <select 
              id={`${subKeySid}-session-config`}
              ref={(input) => { this.sessionConfigurations = this.sessionConfigurations || {}; this.sessionConfigurations[`${subKeySid}`] = input }}
              onChange={e => this.handleSessionConfigurationInput(e, subKeySid)}
              value={currentSessionConfigSid}
            >
              {configurations.map(config => (
                <option key={config.sid} value={config.sid}>
                  {config.name}
                </option>
              ))}
            </select>
          </label>
        </div>
      );
    }
    
    return null;
  }

  renderModalityPresetDropdown(subKeySid, translation) {
    const REMOTE_PROCTOR_TYPE_SIDS = [
      'TS4b894875d26194988853e490dfb9bc41',
      'TS6d6011935f4646848ea4f7a29b4f61a5',
      'TS9531c6b112f145018dae3cd2a9f60c4c',
      'TS63dda27a6ba54c218449b934b7bb1ba8'
    ];

    if (!REMOTE_PROCTOR_TYPE_SIDS.includes(subKeySid)) {
      return null;
    }

    const index = this.subKeyIndex(subKeySid);

    if (!~index) {
      return null;
    }

    const currentProctorType = this.state.settings.proctorTypes[index];

    if (!currentProctorType || currentProctorType.status === 'disabled') {
      return null;
    }

    const { ExamStore } = this.props.store;
    const presets = ExamStore.modalityPresets || [];
    const currentPresetSid = currentProctorType.modalityOptionPresetSid || '';

    return (
      <div className="switch-list__option session-configuration-dropdown">
        <label htmlFor={`${subKeySid}-modality-preset`}>
          {translation.proctor_types.modality_preset}
        </label>
        <label className="select" htmlFor={`${subKeySid}-modality-preset`}>
          <select
            id={`${subKeySid}-modality-preset`}
            onChange={e => this.handleModalityPresetInput(e, subKeySid)}
            value={currentPresetSid}
            required={currentProctorType.status === 'enabled' || currentProctorType.status === 'required' || currentProctorType.status === 'enabled-default'}
          >
            <option value="">{translation.proctor_types.select_preset}</option>
            {presets.map(preset => (
              <option key={preset.sid} value={preset.sid}>
                {preset.title}
              </option>
            ))}
          </select>
        </label>
      </div>
    );
  }

  handleSubmit() {
    let settings = { ...this.state.settings };

    if(settings.sid) {
      delete settings.sid;
    }

    if(settings.createdDate) {
      delete settings.createdDate;
    }

    if(settings.editDate) {
      delete settings.editDate;
    }


    const REMOTE_PROCTOR_TYPE_SIDS = [
      'TS4b894875d26194988853e490dfb9bc41',
      'TS6d6011935f4646848ea4f7a29b4f61a5',
      'TS9531c6b112f145018dae3cd2a9f60c4c',
      'TS63dda27a6ba54c218449b934b7bb1ba8'
    ];

    const fieldsToCleanup = [
      'sessionConfigurationSid',
      'modalityOptionPresetSid',
      'maxReconnectionAttempts', 
      'reconnectionLockoutPeriod',
      'reconnectionInSessionLockoutPeriod'
    ];

    for(let i = 0; i < settings.proctorTypes.length; i++) {
      if (settings.proctorTypes[i].sid) delete settings.proctorTypes[i].sid;
      
      fieldsToCleanup.forEach(field => {
        if(settings.proctorTypes[i][field] === null || settings.proctorTypes[i][field] === undefined) {
          delete settings.proctorTypes[i][field];
        }
      });
      
      if(settings.proctorTypes[i].status === 'disabled') {
        delete settings.proctorTypes[i].maxReconnectionAttempts;
        delete settings.proctorTypes[i].reconnectionLockoutPeriod;
        delete settings.proctorTypes[i].reconnectionInSessionLockoutPeriod;
        delete settings.proctorTypes[i].modalityOptionPresetSid;
      }

      // Remove modalityOptionPresetSid for non-remote proctor types
      if (!REMOTE_PROCTOR_TYPE_SIDS.includes(settings.proctorTypes[i].proctorTypeSubCategorySid)) {
        delete settings.proctorTypes[i].modalityOptionPresetSid;
      }
    }

    // The API returns defaultNewExamType as lowercase
    // but requires it as capitalized………………
    if(settings.defaultNewExamType) {
      settings.defaultNewExamType = settings.defaultNewExamType[0].toUpperCase() + settings.defaultNewExamType.substring(1);
    }

    // If written is disabled, set defaultNewExamType to Online
    if(!settings.enableWrittenExams) {
      settings.defaultNewExamType = 'Online';
    }

    this.props.store.SettingsStore.putInstituteSettings(settings, this, this.complete);
  }

  complete() {
    this.props.store.SessionStore.showToaster(this.props.translation.settings_saved, 'success');
  }

  renderProctorTypesEnabled() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { settings } = this.props.store.SettingsStore;
    let proctorTypes = {};


    if (settings.proctorTypes) settings.proctorTypes.forEach(proctorType => {
      if (proctorType.proctorTypeSubCategorySid) {
        proctorTypes[proctorType.proctorTypeSubCategorySid] = proctorType;
      }
    });

    let sessionConfigurationType = {};

    if (SessionStore.sessionConfigurations) {
      SessionStore.sessionConfigurations.forEach(config => {
        const subTypeSid = config.subCategoryType && config.subCategoryType.sid;
        if (subTypeSid) {
          sessionConfigurationType[subTypeSid] = sessionConfigurationType[subTypeSid] || [];
          sessionConfigurationType[subTypeSid].push(config);
        }
      });
    }


    return (
      <fieldset className="form-section">
        {SessionStore.proctorTypeList.map(
          (key, i) =>
            <div className="form-subgroup" key={i}>
              <strong className="form-subheading proctor-type-heading">{key.title}</strong>

              <ul className="switch-list switch-list--wrap">
                {key.subCategories.map(
                  (subKey, j) =>
                    <li className="proctor-type-subcategory" key={j}>
                      <label
                       htmlFor={subKey.sid} className="proctor-type-subcategory-label">{subKey.title}</label>
                      <label className="select" htmlFor={key.sid}>
                        <select id={subKey.sid}
                          ref={(input) => { this.subCategories[`${subKey.sid}`] = input }}
                          onChange={e => this.handleProctorTypeStatusInput(e, subKey.sid)}
                          defaultValue={
                            proctorTypes[subKey.sid] ?
                              proctorTypes[subKey.sid].status :
                              'disabled'
                          }
                        >
                          <option value="disabled">{translation.proctor_types.options.disabled}</option>
                          <option value="enabled">{translation.proctor_types.options.enabled}</option>
                          <option value="enabled-default">{translation.proctor_types.options.enabled_default}</option>
                          <option value="required">{translation.proctor_types.options.required}</option>
                        </select>
                      </label>
                      
                      { //this.subKeyIndex(subKey.sid) !== -1 &&
                        this.renderApproveOption(this.subKeyIndex(subKey.sid), translation)
                      }
                      
                      {this.renderModalityPresetDropdown(subKey.sid, translation)}

                      {this.renderSessionConfigurationDropdown(subKey.sid, sessionConfigurationType, translation)}

                      {this.renderReconnectionFields(this.subKeyIndex(subKey.sid), subKey.sid, proctorTypes[subKey.sid], sessionConfigurationType, translation)}

                    </li>
                )}
              </ul>
            </div>
        )}
      </fieldset>
    )
  }

  renderProctorTypesDisabled() {
    const { translation } = this.props;
    const { SessionStore } = this.props.store;
    const { settings } = this.props.store.SettingsStore;
    let proctorTypes = {};

    if (settings.proctorTypes) settings.proctorTypes.forEach(proctorType => {
      if (proctorType.proctorTypeSubCategorySid) {
        proctorTypes[proctorType.proctorTypeSubCategorySid] = proctorType;
      }
    });

    return (
      <fieldset className="form-section">
        <p className="note note--prominent">
          {translation.proctor_types.disabled}
        </p>

        {SessionStore.proctorTypeList.map(
          (key, i) =>
            <div className="form-subgroup" key={i}>
              <strong className="form-subheading">{key.title}</strong>

              <ul className="switch-list switch-list--wrap">
                {key.subCategories.map(
                  (subKey, j) =>
                    <li key={j}>
                      <label htmlFor={subKey.sid}>{subKey.title}</label>
                      <label className="select" htmlFor={key.sid}>
                        <select id={subKey.sid}
                          ref={(input) => { this.subCategories[`${subKey.sid}`] = input }}
                          defaultValue={
                            proctorTypes[subKey.sid] ?
                              proctorTypes[subKey.sid].status :
                              'disabled'
                          }
                          disabled
                        >
                          <option value="disabled">{translation.proctor_types.options.disabled}</option>
                          <option value="enabled">{translation.proctor_types.options.enabled}</option>
                          <option value="required">{translation.proctor_types.options.required}</option>
                        </select>
                      </label>

                      { //this.subKeyIndex(subKey.sid) !== -1 &&
                        this.renderApproveOption(this.subKeyIndex(subKey.sid), translation, true)
                      }
                    </li>
                )}
              </ul>
            </div>
        )}
      </fieldset>
    )
  }

  render() {
    const { translation } = this.props;
    const { AdminStore, SessionStore } = this.props.store;

    // Don’t use the default tab styles
    Tabs.setUseDefaultStyles(false);

    if(SessionStore.loadingCalls.indexOf('InstitutionSettings') < 0) {
      return (
        <div className="wrap block-form">
          <form className="panel" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
            <div className="panel__header">
              <h3 className="panel__title"><legend>{translation.heading}</legend></h3>
            </div>

            <div className="panel__body">
              <Tabs
                onSelect={this.handleTabs}
                forceRenderTabPanel={true}
                selectedIndex={this.state.activeTab - 1}
              >
                <TabList className="tabs-enabled">
                  <Tab>{translation.general}</Tab>
                  <Tab>{translation.exam}</Tab>
                  <Tab>{translation.proctor_types.heading}</Tab>
                </TabList>

                <TabPanel>
                  <h4 className="meta">{translation.general}</h4>

                  <fieldset className="form-section">
                    <ul className="fields">
                      <li>
                        <label
                          className="lbl-required"
                          htmlFor="settings-timezone"
                        >
                          {translation.timezone.label}
                        </label>

                        <label
                          className="select"
                          htmlFor="settings-timezone"
                        >
                          <select
                            id="settings-timezone"
                            required
                            aria-required="true"
                            ref={(input) => { this.defaultTimezone = input }}
                            value={this.state.settings.defaultTimezone}
                            onChange={e => this.handleInput(e)}
                          >
                            <option value="">{translation.timezone.helper}</option>
                            {SessionStore.timezoneList.map(
                              (key, i) =>
                                <option key={i} value={key.sid}>{key.name}</option>
                            )}
                          </select>
                        </label>
                      </li>
                      <li>
                        <label
                          className="lbl-required"
                          htmlFor="settings-currency"
                        >
                          {translation.currency.label}
                        </label>

                        <label
                          className="select"
                          htmlFor="settings-currency"
                        >
                          <select
                            id="settings-currency"
                            required
                            aria-required="true"
                            ref={(input) => { this.defaultCurrencyCode = input }}
                            value={this.state.settings.defaultCurrencyCode}
                            onChange={e => this.handleInput(e)}
                          >
                            <option value="">{translation.currency.helper}</option>
                            {SessionStore.currencyList.map(
                              (key, i) =>
                                <option key={i} value={key.code}>{key.name}</option>
                            )}
                          </select>
                        </label>
                      </li>
                      <li>
                        <label
                          className="lbl-required"
                          htmlFor="settings-course-offering"
                          aria-describedby="course-offering-tooltip"
                        >
                          {translation.course_offering.label}

                          <div className="tooltip">
                            <span
                              className="tooltip__label"
                              role="presentation"
                              aria-hidden="true"
                            >(?)</span>

                            <div
                              id="course-offering"
                              className="tooltip__body"
                              role="tooltip"
                            >
                              {translation.course_offering.tooltip}
                            </div>
                          </div>
                        </label>

                        <label
                          className="select"
                          htmlFor="settings-course-offering"
                        >
                          <select
                            id="settings-course-offering"
                            ref={(input) => { this.defaultCourseOfferingSid = input }}
                            value={this.state.settings.defaultCourseOfferingSid || ''}
                            onChange={e => this.handleInput(e)}
                          >
                            <option value="">{translation.course_offering.helper}</option>
                            {AdminStore.courseOfferings.map(
                              (key, i) =>
                                <option key={i} value={key.sid}>{key.title}</option>
                            )}
                          </select>
                        </label>
                      </li>
                    </ul>
                  </fieldset>
                </TabPanel>

                <TabPanel>
                  <h4 className="meta">{translation.exam}</h4>

                  <fieldset className="form-section">
                    <strong className="form-section__heading">
                      {translation.written_exams.heading}
                    </strong>

                    <ul className="fields">
                      <li>
                        <input
                          type="checkbox"
                          id="enable-written"
                          className="switch-input"
                          ref={(input) => this.enableWrittenExams = input}
                          value={true}
                          defaultChecked={this.state.settings.enableWrittenExams}
                          onChange={(e) => this.handleInput(e)}
                          onKeyDown={handleSwitchInputKeys}
                        />

                        <label
                          className="switch-label"
                          htmlFor="enable-written"
                        >
                          <span className="meta">{translation.enable_written.label}</span>
                        </label>

                        <label
                          className="switch-label--alt"
                          htmlFor="enable-written"
                          aria-describedby="enable-written-tooltip"
                        >
                          {translation.enable_written.label}

                          <div className="tooltip">
                            <span className="tooltip__label">(?)</span>
                            <div id="enable-written-tooltip" className="tooltip__body" role="tooltip">
                              {translation.enable_written.tooltip}
                            </div>
                          </div>
                        </label>
                      </li>
                      {this.state.settings.enableWrittenExams &&
                        <li>
                          <label className="lbl-required" htmlFor="exam-type">
                            {translation.exam_type.label}
                          </label>

                          <label className="select" htmlFor="exam-type">
                            <select
                              id="exam-type"
                              ref={(input) => this.defaultNewExamType = input}
                              defaultValue={this.state.settings.defaultNewExamType}
                              required
                              aria-required="true"
                              onChange={(e) => this.handleInput(e)}
                            >
                              <option value="online">{translation.exam_type.online}</option>
                              <option value="written">{translation.exam_type.written}</option>
                            </select>
                          </label>
                        </li>
                      }
                    </ul>
                  </fieldset>

                  <fieldset className="form-section">
                    <ul className="fields">
                      <li className="field--separator">
                        <label className="lbl-optional" htmlFor="settings-exam-notes" aria-describedby="exam-notes-tooltip">
                          {translation.exam_notes.label}

                          <div className="tooltip">
                            <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                            <div id="exam-notes-tooltip" className="tooltip__body" role="tooltip">
                              {translation.exam_notes.tooltip}
                            </div>
                          </div>
                        </label>

                        <Textarea
                          id="settings-exam-notes"
                          className="textarea-grow"
                          onChange={e => this.handleInput(e)}
                          ref={(input) => {this.examNotes = input}}
                          value={this.state.settings.examNotes || ''}></Textarea>
                      </li>
                    </ul>
                  </fieldset>


                  <fieldset className="form-section">
                    <strong className="form-section__heading">
                      {translation.permitted_items.label}

                      <div className="tooltip">
                        <span className="tooltip__label" role="presentation" aria-hidden="true">(?)</span>
                        <div id="exam-notes-tooltip" className="tooltip__body" role="tooltip">
                          {translation.permitted_items.helper}
                        </div>
                      </div>
                    </strong>

                    <ul className="switch-list">
                      {Object
                        .keys(translation.permitted_items.options)
                        .map(
                          (key) =>
                          <li key={key}>
                            <label htmlFor={key}>{translation.permitted_items.options[key]}</label>

                            <input
                              type="checkbox"
                              id={key}
                              className="switch-input"
                              onChange={(e) => this.handlePermittedItem(e, key)}
                              onKeyDown={handleSwitchInputKeys}
                              defaultChecked={this.state.settings.hidePermittedItemFields.indexOf(key) < 0}
                            />

                            <label className="switch-label" htmlFor={key}><span className="meta">{translation.permitted_items.options[key]}</span></label>
                          </li>
                        )
                      }
                    </ul>
                  </fieldset>

                  <fieldset className="form-section">
                    <ul className="fields">
                      <li>
                        <label className="lbl-required">{translation.exam_approval.label}</label>

                        <input
                          type="radio"
                          name="examApproval[]"
                          id="settings-exam-approval-01"
                          value={true}
                          checked={this.state.settings.requireManagerExamApproval}
                          onChange={(e) => {this.toggleOption(e, 'requireManagerExamApproval')}}
                          required
                          aria-required="true"
                        />
                        <label className="radio-alt" htmlFor="settings-exam-approval-01">
                          <strong>{translation.exam_approval.yes}</strong>–{translation.exam_approval.yes_body}
                        </label>

                        <input
                          type="radio"
                          name="examApproval[]"
                          id="settings-exam-approval-02"
                          value={false}
                          checked={!this.state.settings.requireManagerExamApproval}
                          onChange={(e) => {this.toggleOption(e, 'requireManagerExamApproval')}}
                          required
                          aria-required="true"
                        />
                        <label className="radio-alt" htmlFor="settings-exam-approval-02">
                          <strong>{translation.exam_approval.no}</strong>–{translation.exam_approval.no_body}
                        </label>
                      </li>
                      <li>
                        <label className="lbl-required">{translation.proctor_approval.label}</label>

                        <input
                          type="radio"
                          name="adminApproval[]"
                          id="settings-proctor-approval-01"
                          value={true}
                          checked={this.state.settings.requireManagerProctorApproval}
                          onChange={(e) => {this.toggleOption(e, 'requireManagerProctorApproval')}}
                          required
                          aria-required="true"
                        />
                        <label className="radio-alt" htmlFor="settings-proctor-approval-01">
                          <strong>{translation.proctor_approval.yes}</strong>–{translation.proctor_approval.yes_body}
                        </label>

                        <input
                          type="radio"
                          name="adminApproval[]"
                          id="settings-proctor-approval-02"
                          value={false}
                          checked={!this.state.settings.requireManagerProctorApproval}
                          onChange={(e) => {this.toggleOption(e, 'requireManagerProctorApproval')}}
                          required
                          aria-required="true"
                        />
                        <label className="radio-alt" htmlFor="settings-proctor-approval-02">
                          <strong>{translation.proctor_approval.no}</strong>–{translation.proctor_approval.no_body}
                        </label>
                      </li>

                      <li className="form-section">
                        <strong className="form-section__heading">{translation.AI.heading}</strong>
                        <input
                          type="checkbox"
                          id="ai-toggle"
                          defaultChecked={this.state.settings.facialProcessing && this.state.settings.facialProcessing !== 'off'}
                          ref={(input) => this.facialProcessing = input}
                          className="switch-input"
                          onKeyDown={handleSwitchInputKeys}
                          onChange={(e) => this.handleInput(e)}
                        />
                        <label className="switch-label" htmlFor="ai-toggle"><span className="meta">{translation.AI.label}</span></label>

                        <label className="switch-label--alt" htmlFor="ai-toggle">{translation.AI.label}</label>
                      </li>
                      
                      <li>
                        <input
                          type="checkbox"
                          defaultChecked={this.state.settings.pauseForProctorReview}
                          id="student-verification"
                          ref={(input) => this.pauseForProctorReview = input}
                          className="switch-input"
                          onKeyDown={handleSwitchInputKeys}
                          onChange={(e) => this.handleInput(e)}
                        />

                        <label
                          className="switch-label"
                          htmlFor="student-verification"
                        >
                          <span className="meta">{translation.student_verification}</span>
                        </label>

                        <label
                          className="switch-label--alt"
                          htmlFor="student-verification"
                        >
                          {translation.student_verification}
                        </label>
                      </li>

                    </ul>
                  </fieldset>
                </TabPanel>

                <TabPanel>
                  <h4 className="meta">{translation.proctor_types.heading}</h4>

                  <FeatureFlag
                    flagKey="institution-proctor-types"
                    renderFeatureCallback={this.renderProctorTypesEnabled}
                    renderDefaultCallback={this.renderProctorTypesDisabled}
                  />
                </TabPanel>
              </Tabs>

              <div className="panel__actions actions">
                <button
                  className="actions__btn actions__btn--primary"
                  type="submit"
                >
                  {translation.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      )
    }

    return null;
  }
})

export default translate('InstitutionSettings')(InstitutionSettings);



// WEBPACK FOOTER //
// ./src/app/components/Settings/InstitutionSettings.js